<div class="table-responsive">
    <table class="table custom-ui-table mb-0 w-100">
            <thead>
                <tr>
                    <th style="width: 50px;"></th>
                    <th>Mittente</th>
                    <th>Oggetto</th>
                    <th style="width: 150px;" class="text-end">Data</th>
                    <th style="width: 50px;"></th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngIf="messages.length > 0; else noMessages">
                    <tr *ngFor="let message of messages" (click)="readMessage(message)" class="cursor-pointer">
                        <td>
                            <span *ngIf="isSent(message); else readIcon" class="message-icon-wrapper" title="Inviato">
                                <i class="bi bi-send text-muted" style="font-size: 1.1rem;"></i>
                            </span>
                            <ng-template #readIcon>
                                <span class="message-icon-wrapper" [attr.title]="message.seen ? 'Già letto' : 'Da leggere'">
                                    <i class="bi" [ngClass]="message.seen ? 'bi-eye text-muted' : 'bi-eye-fill text-primary'" style="font-size: 1.2rem;"></i>
                                </span>
                            </ng-template>
                        </td>
                        <td>
                            <div *ngIf="isSent(message); else senderCell" class="flex min-w-0 items-center gap-2">
                                <span class="shrink-0 text-xs font-semibold uppercase text-slate-400">A</span>
                                <span class="inline-flex max-w-[14rem] items-center gap-1.5 truncate rounded-full bg-slate-100 px-2.5 py-0.5 text-xs font-semibold text-slate-700">
                                    <i class="bi" [ngClass]="recipientIcon(message)" aria-hidden="true"></i>
                                    <span class="truncate">{{ message.recipientLabel }}</span>
                                </span>
                            </div>
                            <ng-template #senderCell>
                                <div class="d-flex align-items-center">
                                    <span class="sender-avatar me-2">{{ senderInitial(message) }}</span>
                                    <span class="fw-medium text-dark">{{ senderName(message) }}</span>
                                </div>
                            </ng-template>
                        </td>
                        <td>
                            <span [class.fw-bold]="!message.seen" class="text-dark">
                                {{ message.title }}
                            </span>
                            <span *ngIf="isSent(message)" class="ml-2 whitespace-nowrap text-xs font-medium"
                                  [ngClass]="message.seenCount === message.recipientsCount ? 'text-primary' : 'text-slate-400'">
                                <i class="bi bi-check2-all" aria-hidden="true"></i> {{ message.seenCount }}/{{ message.recipientsCount }} letti
                            </span>
                        </td>
                        <td class="text-end text-muted">
                            {{ formatMessageTime(message.createdAt) }}
                        </td>
                        <td class="text-center">
                            <i class="bi bi-chevron-right text-muted"></i>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>

        <ng-template #noMessages>
            <tr>
                <td colspan="5" class="text-center py-5 text-muted">
                    <i class="bi bi-inbox mb-2 d-block" style="font-size: 2rem; opacity: 0.3;"></i>
                    Nessun messaggio presente
                </td>
            </tr>
        </ng-template>
    </div>
